<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 companies-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div class="breadcrumbs-section padding-left">
        <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">FAQs</span>
      </div>

      <div class="faq-layout">
        <div class="row mb-2">
          <div class="col-10">
            <h1>FAQs</h1>
          </div>
          <!-- <div class="col-2  justify-content-end">
            <button (click)="addFaq()">Add FAQ</button>
          </div> -->
        </div>
        <div class="row mt-3" *ngFor="let item of content;let i=index">
          <div class="col-12">
            <div class="faq-content ">
              <div class="row">
                <div class="col-11">
                  <div class="faq-ques">{{item.question}}</div>
                </div>

                <div class="col-1" *ngIf="faqEdit || faqRemove">
                  <div class="list-option pl-4" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                    [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover"
                    (click)="$event.stopPropagation();openPopover(p1)" placement="bottom">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <ng-template #popContent1>
                      <div>
                        <div class="popover-content" style="cursor: pointer;"
                          (click)="$event.stopPropagation();closePopover(p1);edit(item.id)" *ngIf="faqEdit">Edit</div>
                        <div class="popover-content" style="cursor: pointer;"
                          (click)="$event.stopPropagation();closePopover(p1);deleteFaq(item.id)" *ngIf="faqRemove">Delete</div>
                      </div>
                    </ng-template>
                  </div>
                </div>

              </div>
              <div class="row mt-2">
                <div class="col-11">
                  <div class="faq-ans">{{item.answer}}</div>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>